import { inject, Injectable } from '@angular/core';
import { UserUnifiedService } from '@thiememeulenhoff/ng-api-gateway';
import { UserData } from '@thiememeulenhoff/types';
import { tap } from 'rxjs';
import { UserRecentFacade } from '../user-recent/user-recent.facade';
import { PreferenceStore } from '../preference/preference.store';
import { UserSettingFacade } from '../user-setting/user-setting.facade';

@Injectable({
  providedIn: 'root',
})
export class UserUnifiedFacade {
  readonly #userUnifiedService = inject(UserUnifiedService);

  readonly #preferenceStore = inject(PreferenceStore);

  readonly #userSettingsFacade = inject(UserSettingFacade);

  readonly #userRecentFacade = inject(UserRecentFacade);

  initialize() {
    this.fetchUserData().subscribe();
  }

  fetchUserData() {
    return this.#userUnifiedService.fetchUserData().pipe(
      tap((userData: UserData) => {
        const preferences = userData.methodPreferences;
        this.#preferenceStore.setMethodPreferences(preferences);

        const settings = userData.userSettings;
        this.#userSettingsFacade.setUserSettings(settings);

        this.#userRecentFacade.setRecents([
          ...(userData.recentMethods ?? []),
          ...(userData.recentArrangements ?? []),
          ...(userData.recentResources ?? []),
        ]);
      }),
    );
  }
}
